import { AlreadyTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { AttributeResource } from '../../../Types';

export interface Props {
  competency: AttributeResource;
}

function CompetencyLabel({ competency }: Props) {
  return competency.payload.name
    .map((name) => (
      <div
        className="text-gray-900 border border-gray-900 break-keep inline-block rounded-md py-1
                   px-2 text-xs font-medium tracking-tight"
      >
        <AlreadyTranslated content={name} />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(CompetencyLabel);
